import { Axios } from '../axios';

import { VoladeumAdapters } from './adapters';
import { VoladeumAuth } from './auth';
import { VoladeumCandleValidations } from './candle-validations';
import { VoladeumCandleWorkers } from './candle-workers';
import { VoladeumCandles } from './candles';
import { VoladeumContractTypes } from './contract-types';
import { VoladeumCurrencies } from './currencies';
import { VoladeumExpiryMethods } from './expiry-methods';
import { VoladeumIndicators } from './indicators';
import { VoladeumOperators } from './operators';
import { VoladeumPairs } from './pairs';
import { VoladeumSignal } from './signal';
import { VoladeumSizingMethods } from './sizing-methods';
import { VoladeumStatuses } from './statuses';
import { VoladeumStrategies } from './strategies';
import { VoladeumStrikeMethods } from './strike-methods';
import { VoladeumTriggerTypes } from './trigger-types';
import { VoladeumUsers } from './users';

export class VoladeumAxios extends Axios {
  public readonly auth: VoladeumAuth;
  public readonly users: VoladeumUsers;
  public readonly currencies: VoladeumCurrencies;
  public readonly pairs: VoladeumPairs;
  public readonly candles: VoladeumCandles;
  public readonly candleWorkers: VoladeumCandleWorkers;
  public readonly candleValidations: VoladeumCandleValidations;
  public readonly adapters: VoladeumAdapters;
  public readonly strategies: VoladeumStrategies;
  public readonly signal: VoladeumSignal;
  public readonly sizingMethods: VoladeumSizingMethods;
  public readonly strikeMethods: VoladeumStrikeMethods;
  public readonly expiryMethods: VoladeumExpiryMethods;
  public readonly contractTypes: VoladeumContractTypes;
  public readonly operators: VoladeumOperators;
  public readonly statuses: VoladeumStatuses;
  public readonly triggerTypes: VoladeumTriggerTypes;
  public readonly indicators: VoladeumIndicators;

  constructor(host = '') {
    super(host);
    this.auth = new VoladeumAuth(host);
    this.users = new VoladeumUsers(host);
    this.currencies = new VoladeumCurrencies(host);
    this.pairs = new VoladeumPairs(host);
    this.candles = new VoladeumCandles(host);
    this.candleWorkers = new VoladeumCandleWorkers(host);
    this.candleValidations = new VoladeumCandleValidations(host);
    this.adapters = new VoladeumAdapters(host);
    this.strategies = new VoladeumStrategies(host);
    this.signal = new VoladeumSignal(host);
    this.contractTypes = new VoladeumContractTypes(host);
    this.strikeMethods = new VoladeumStrikeMethods(host);
    this.expiryMethods = new VoladeumExpiryMethods(host);
    this.sizingMethods = new VoladeumSizingMethods(host);
    this.operators = new VoladeumOperators(host);
    this.statuses = new VoladeumStatuses(host);
    this.triggerTypes = new VoladeumTriggerTypes(host);
    this.indicators = new VoladeumIndicators(host);
  }
}
